export const COUPONS = {
  SIGNON_FEE_COUPONS: ['NSSADISC26', 'BK-PARTNERSHIP', 'BKPARTNERSHIP', 'SITARA3', 'ESSA35'],
  SIGNON_FEE_COUPONS_OFF_50_WITH_TAX: ['ESSA35'],
  ESIGN_ONLY_COUPONS: ['ESSA35'],
  ESSENTIALS_COUPONS: [
    'WOL50125',
    'WOL50225',
    'NSSADISC26',
    'WOL25125',
    'WOL25225',
    'APA10026',
    '100FREEINTERNALUSESTAFFBK',
    'APAPREMIUM26',
    'WOL100125',
    'WOL100225',
    'SCT2MONTHSFREE',
    'SCT12MONTHS',
    'BK-PARTNERSHIP',
    'ROB-12MONTHS',
    'CMAA-12MONTHS',
    'PGA-12MONTHS',
    'CTR-12MONTHS',
    'DC-12MONTHS',
    'RN-12MONTHS',
    'BA-12MONTHS',
    'WC-12MONTHS',
    'TR-12MONTHS',
    'RB-12MONTHS',
    'APA-12MONTHS',
    'ESSA-12MONTHS',
    'NSSA-12MONTHS',
    'SCT-12MONTHS',
    'SITARA3',
    'BKPARTNERSHIP',
    'ESSA35',
  ],
  GROWTH_COUPONS: [
    'NSSADISC26',
    '100FREEINTERNALUSESTAFFBK',
    'BK-PARTNERSHIP',
    'ROB-12MONTHS',
    'CMAA-12MONTHS',
    'PGA-12MONTHS',
    'CTR-12MONTHS',
    'DC-12MONTHS',
    'RN-12MONTHS',
    'BA-12MONTHS',
    'WC-12MONTHS',
    'TR-12MONTHS',
    'RB-12MONTHS',
    'APA-12MONTHS',
    'ESSA-12MONTHS',
    'NSSA-12MONTHS',
    'SCT-12MONTHS',
    'SITARA3',
    'BKPARTNERSHIP',
    'ESSA35',
  ],
  FOUR_DOLLAR_COUPONS: ['APADISC26', 'APADISC426'],
  OFF_100_COUPONS: [
    'APA10026',
    'APAPREMIUM26',
    '100FREEINTERNALUSESTAFFBK',
    'WOL100125',
    'WOL100225',
    'SCT2MONTHSFREE',
    'SCT12MONTHS',
    'BK-PARTNERSHIP',
    'ROB-12MONTHS',
    'CMAA-12MONTHS',
    'PGA-12MONTHS',
    'CTR-12MONTHS',
    'DC-12MONTHS',
    'RN-12MONTHS',
    'BA-12MONTHS',
    'WC-12MONTHS',
    'TR-12MONTHS',
    'RB-12MONTHS',
    'APA-12MONTHS',
    'ESSA-12MONTHS',
    'NSSA-12MONTHS',
    'SCT-12MONTHS',
    'SITARA3',
    'BKPARTNERSHIP',
  ],
  OFF_50_COUPONS: ['WOL50125', 'WOL50225', 'NSSADISC26'],
  OFF_35_WITH_TAX_COUPONS: ['ESSA35'],
  OFF_25_COUPONS: ['WOL25125', 'WOL25225'],
  PROD_COUPONS: [
    'APADISC26',
    'APA10026',
    'SCT2MONTHSFREE',
    'SCT12MONTHS',
    '100FREEINTERNALUSESTAFFBK',
    'WOL100125',
    'WOL100225',
    'WOL50125',
    'WOL50225',
    'WOL25125',
    'WOL25225',
    'APADISC426',
    'APAPREMIUM26',
    'NSSADISC26',
    'BK-PARTNERSHIP',
    'ROB-12MONTHS',
    'CMAA-12MONTHS',
    'PGA-12MONTHS',
    'CTR-12MONTHS',
    'DC-12MONTHS',
    'RN-12MONTHS',
    'BA-12MONTHS',
    'WC-12MONTHS',
    'TR-12MONTHS',
    'RB-12MONTHS',
    'APA-12MONTHS',
    'ESSA-12MONTHS',
    'NSSA-12MONTHS',
    'SCT-12MONTHS',
    'SITARA3',
    'BKPARTNERSHIP',
    'ESSA35',
  ],
  UAT_COUPONS: [
    'APADISC26',
    'APA10026',
    'SCT2MONTHSFREE',
    'SCT12MONTHS',
    '100FREEINTERNALUSESTAFFBK',
    'WOL100125',
    'WOL100225',
    'WOL50125',
    'WOL50225',
    'WOL25125',
    'WOL25225',
    'APADISC426',
    'APAPREMIUM26',
    'NSSADISC26',
    'BKPARTNERSHIP',
    'ESSA35',
  ],
  DEV_COUPONS: ['APA10026', 'APADISC26', 'APADISC426'],
  LOCAL_COUPONS: ['NSSADISC26', 'APA10026', 'APADISC426', 'WOL50125', 'WOL25125', 'ESSA35'],
};
